import React, { useEffect, useRef } from "react";
import classnames from 'classnames';
import WindowEventHelper from "../../lib/WindowEventHelper";
import {isDescendant} from "../../utils/DomHelper";

export default function SimpleDialog(props) {
  const { title, className, style, validated, onSubmit, onClose, children } = props;
  const rootEl = useRef(null);

  useEffect(() => {
    WindowEventHelper.add("click", handleWindowClick);
    document.body.className = "scroll_hide";
    return () => {
      WindowEventHelper.remove("click", handleWindowClick);
      document.body.className = "";
    }
  }, []);

  function handleWindowClick(e) {
    if (!isDescendant(rootEl.current, e.target)) {
      onClose();
    }
  }

  function handleReset() {
    onClose()
  }

  function handleSubmit(e) {
    if (validated && !onSubmit(e)) {
      e.preventDefault();
    }
  }

  return (
    <div className='container_layer'>
      <div className="blog_layer" style={style}>
        <div ref={rootEl} className={`inner_blog_layer ${className}`}>
          <form onSubmit={handleSubmit} onReset={handleReset}>
            <div className="cont_layer">
              <strong className="tit_popup">{ title }</strong>
              {children}
            </div>

            <div className="fld_btn">
              <button type="reset" className="btn_cancel">취소</button>
              <button type="submit" className={classnames("btn_default", {"btn_off": !validated})} disabled={!validated}>확인</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
